'use client';

import { useEffect } from 'react';

interface DomainRedirectProps {
  children: React.ReactNode;
}

const DomainRedirect: React.FC<DomainRedirectProps> = ({ children }) => {
  useEffect(() => {
    const currentHostname = window.location.hostname;
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const currentHash = window.location.hash;

    // Define domain mappings for both staging and production
    const domainMappings: Record<string, string> = {
      'coffee.groupondev.com': 'coffee-app.groupondev.com',
      'coffee-staging.groupondev.com': 'coffee-app-staging.groupondev.com',
    };

    // Check if current domain needs to be redirected
    const newDomain = domainMappings[currentHostname];

    if (newDomain) {
      // Construct the new URL preserving path, query params, and hash
      const newUrl = `https://${newDomain}${currentPath}${currentSearch}${currentHash}`;

      // Perform the redirect
      window.location.replace(newUrl);
    }
  }, []);

  return <>{children}</>;
};

export default DomainRedirect;
